import { ReactComponent as CircuitSVG } from '../../images/rightCircuit.svg';
import './circuit.css';

const AnimatedCircuitRight = () => {
  return (
    <div className="line-wrapper2">
    <div className="svg-container">
          <CircuitSVG />
    </div>
    </div>
  )
}
export default AnimatedCircuitRight;